import React from 'react'
import { Group } from '@mantine/core'
import IonIcon from '@reacticons/ionicons'

interface StepHeaderProps {
    title?: string
    onClose: () => void
}

export function StepHeader({ title, onClose }: StepHeaderProps) {
    return (
        <Group w="100%" position="apart" className="modal-step-header-container" align="center" mb="md">
            {title ? (
                <h1 className="modal-step-header-title">{title}</h1>
            ) : (
                <div />
            )}
            <IonIcon
                name="close-outline"
                className="modal-step-header-close-icon"
                onClick={onClose}
                style={{ fontSize: '20px', width: '20px', height: '20px' }}
            />
        </Group>
    )
}

export default StepHeader